import { atom } from "recoil";

export const kintoneArrayState = atom({
  key: "kintoneArrawyState",
  default: [],
});
